import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../constants";
import { useHistory } from "react-router-dom";

const EmailFrequencySelect = ({ motor, token, setMotor }) => {
  const [emailFrequency, setEmailFrequency] = useState(
    motor.emailFrequency || motor.defaultEmailFrequency || "daily"
  );
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const navigate = useHistory();

  const showMessagePopup = (message) => alert(message);

  const handleEmailFrequencyChange = (e) => setEmailFrequency(e.target.value);

  const handleEmailFrequencyUpdate = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/moteur/frequency`,
        { id_moteur: motor._id, emailFrequency },
        { headers: { Authorization: "Bearer " + token } }
      );

      if (response.status === 401) {
        showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
        localStorage.clear();
        navigate.push("/login");
        return;
      }

      if (response.status === 200) {
        const json = response.data;
        setMotor(json);
        localStorage.setItem("motor", JSON.stringify(json));
        setShowSuccessMessage(true);
        setTimeout(() => setShowSuccessMessage(false), 3000);
      } else {
        console.error("Erreur lors de la mise à jour de la fréquence d'envoi d'e-mails");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (showSuccessMessage) console.log("Fréquence mise à jour avec succès !");
  }, [showSuccessMessage]);

  return (
    <div className="w-full">
      {/* Titre */}
      <h4 className="border-t-4 border-bleuSTB pt-3 pb-3 text-sm sm:text-base md:text-lg xl:text-xl font-bold underline">
        Fréquence d'envoi d'e-mails
      </h4>

      {/* Select + bouton en ligne sur md+, empilés sur mobile */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 mt-3">
        {/* Select */}
        <div className="relative flex-1">
          <select
            className="w-full text-sm sm:text-base md:text-lg mb-4 px-3 py-2 pr-8
                       border border-gray-300 dark:border-gray-500
                       bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100
                       rounded-lg appearance-none
                       focus:outline-none focus:ring-2 focus:ring-bleuSTB focus:border-bleuSTB
                       transition-all duration-150"
            value={emailFrequency}
            onChange={handleEmailFrequencyChange}
            onClick={(e) => e.stopPropagation()}
          >
            <option value="daily">Tous les jours</option>
            <option value="weekly">Toutes les semaines</option>
            <option value="biweekly">Toutes les deux semaines</option>
            <option value="monthly">Tous les mois</option>
          </select>
          {/* Chevron */}
          <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-gray-500 dark:text-gray-300">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        {/* Bouton */}
        <button
          onClick={(e) => { handleEmailFrequencyUpdate(); e.stopPropagation(); }}
          className="w-full sm:w-auto shrink-0 mb-4
                     bg-bleuSTB hover:bg-marronSTB
                     dark:bg-bleuSTB dark:hover:bg-blue-500
                     text-white text-sm sm:text-base md:text-lg font-semibold
                     px-5 py-2 rounded-lg
                     transition-all duration-200"
        >
          Enregistrer
        </button>
      </div>

      {/* Message succès */}
      {showSuccessMessage && (
        <div className="mt-3 flex items-center gap-2 text-green-600 dark:text-green-400 text-sm sm:text-base">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z" clipRule="evenodd" />
          </svg>
          Fréquence mise à jour avec succès !
        </div>
      )}
    </div>
  );
};

export default EmailFrequencySelect;